{
  "customFormsFeaturesData": {
    "titles": {
      "checkOut": "離場登記",
      "checkInDeprecated": "報到（已淘汰）",
      "checkIn": "報到",
      "receivedLoadInspection": "收貨檢查",
      "shippedLoadVerification": "出貨驗證",
      "appointmentsPerLoadType": "依貨物類型預約",
      "assetDetails": "資產詳細資料",
      "yardManagementSystem": "場站管理系統",
      "smartGateIntegration": "SmartGate 整合",
      "gateManagement": "門禁管理",
      "idValidation": "身分驗證",
      "appointmentCompleted": "預約已完成"
    },
    "subtitles": {
      "phoneNumberAndCarrierCompanyWillBeCollectedByDefault": "預設會收集<strong>電話號碼</strong>與<strong>承運公司</strong>"
    },
    "descriptions": {
      "captureCheckInDetailsFromDriversForBothPlannedAndUnplannedArrivals": "收集司機在已排定與未排定抵達時的報到詳細資料。",
      "captureCheckOutDataAfterAnAppointmentIsCompleted": "在預約完成後收集離場資料。",
      "collectDriverInfoAsTheySelfCheckInForTheirPlannedAppointmentThisFeatureIsAnOptionalAddOnToOurGateManagementSolution": "在司機為已排定的預約進行自助報到時收集司機資訊。此功能為我們門禁管理解決方案的選用加購項目。",
      "documentDamageDiscrepanciesOrOtherIssuesRelatedToTheReceivedLoad": "記錄與所收貨物相關的損壞、差異或其他問題。",
      "documentLoadIntegrityAndOtherSecurityMeasuresRelatedToTheShippedLoad": "記錄與所出貨物相關的貨物完整性及其他安全措施。",
      "captureLoadTypeSpecificDetailsDuringAppointmentScheduling": "在預約排程期間收集特定貨物類型的詳細資料。",
      "storeAndTrackDetailsOfTrailersAndContainersAsTheyArriveAtYourYard": "在拖車與貨櫃抵達您的場站時，儲存並追蹤其詳細資料。",
      "enableTheYmsModuleForThisWarehouseAlsoEnableTheAssetVisitFieldsForTheGateManagementApp": "為此倉庫啟用 YMS 模組，同時為門禁管理應用程式啟用資產到訪欄位。",
      "enableTheSmartGateModuleForThisWarehouse": "為此倉庫啟用 SmartGate 模組。",
      "enableTheIdValidationForThisWarehouse": "為此倉庫啟用身分驗證模組。",
      "enableTheGateManagementModuleForThisWarehouseWhichIncludesTheCheckIn": "為此倉庫啟用門禁管理模組，其中包含報到功能",
      "reviewAndManageAppointmentDataAfterCompletion": "在預約完成後檢閱並管理預約資料。"
    },
    "helpLinks": {
      "learnHowItWorksOrContactUsToRequestATrial": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">瞭解運作方式</a>，或與我們聯絡以<a href=\"https://lp.opendock.com/gate-management\" target=\"_blank\">申請試用</a>。",
      "learnHowItWorks": "<a href=\"https://community.loadsmart.com/hc/en-us/articles/19326940613011-Carrier-Self-Check-In\" target=\"_blank\">瞭解運作方式。</a>"
    },
    "enableDisclaimers": {
      "theDriversWillSeeThisFormWhenTheyAreCheckingThemselvesIn": "司機在進行自助報到時會看到此表單。",
      "allFieldsOnThisFormWillBeAvailableAndVisibleDuringAppointmentScheduling": "此表單上的所有欄位在預約排程期間都將<strong>可使用且可見</strong>。"
    },
    "disableDisclaimers": {
      "theDriversWillNotSeeThisFormWhenTheyAreCheckingThemselvesIn": "司機在進行自助報到時將不會看到此表單。",
      "allFieldsOnThisFormWillBeUnavailableDuringAppointmentSchedulingYouCanReEnableThisFormAtAnyTime": "此表單上的所有欄位在預約排程期間都將<strong>無法使用</strong>。<br />您可以隨時重新啟用此表單。"
    },
    "labels": {
      "updateClaimsSupport": "更新索賠佐證",
      "selectAClaimsSupportToUpdate": "選擇要更新的索賠佐證",
      "damageType": "損壞類型",
      "damageDescription": "損壞說明",
      "damagePhotos": "損壞照片",
      "discrepancyType": "差異類型",
      "discrepancyDescription": "差異說明",
      "discrepancyPhotos": "差異照片",
      "loadSecurityChecked": "已檢查貨物安全",
      "loadSecurityDescription": "貨物安全說明",
      "loadIntegrityPhotos": "貨物完整性照片",
      "sealIntegrityPhotos": "封條完整性照片"
    }
  }
}
